import { createContext, useContext, useState, useEffect } from "react";
import { getProjectDatesInfo, setProjectDates } from "api/pointCloud";
import { useVolumeContext } from "./useProjectVolume";

export interface pointCloud {
  name: string;
  id: string;
  scannedAt: string;
  attribute: string;
}

export const UnityContext = createContext<any | null>(null);

export const UnityProvider = ({ children }: { children: any }) => {
  const [projectStartdate, setprojectStartdate] = useState<Date>();
  const [TimelineShown, setTimelineShown] = useState<boolean>(false);
  const [timelineLoading, setTimlineLoading] = useState(false);
  const [projectEnddate, setprojectEnddate] = useState<Date>();
  const [selectedValues, setSelectedValues] = useState<pointCloud[] | null>(
    null
  );
  const [IsBubbleChart, setIsBubbleChart] = useState<boolean>(false);
  const [selectedPointCloudId, setSelectedPointCloudId] = useState<number | null>(null);
  const [pointCloudList, setPointCloudList] = useState([]);
  const { setMaxVolume } = useVolumeContext();

  useEffect(() => {
    const getDateInfo = async () => {
      const response = await getProjectDatesInfo();
      if (response.status === 200) {
        setprojectStartdate(response.data.startDate);
        setprojectEnddate(response.data.endDate);
        setMaxVolume(Number(response.data.plannedVolume));
      }
    };
    getDateInfo();
  }, []);

  function toFixedUTCISOString(dateString: Date) {
    const localDate = new Date(dateString);

    const utcDate = new Date(Date.UTC(
      localDate.getFullYear(),
      localDate.getMonth(),
      localDate.getDate(),
      0, 0, 0, 0
    ));

    return utcDate.toISOString();
  }

  const updateProjectDates = async () => {
    if (projectStartdate && projectEnddate) {
      const start = toFixedUTCISOString(projectStartdate);
      const end = toFixedUTCISOString(projectEnddate);

      const response = await setProjectDates(
        {
          start,
          end
        }
      );
      if (response.status === 200) {
        return;
      }
    }
  };

  useEffect(() => {
    if (projectStartdate) {
      updateProjectDates();
    }
  }, [projectStartdate]);

  useEffect(() => {
    if (projectEnddate) {
      updateProjectDates();
    }
  }, [projectEnddate]);

  return (
    <UnityContext.Provider
      value={{
        projectStartdate,
        setprojectStartdate,
        projectEnddate,
        setprojectEnddate,
        selectedValues,
        setSelectedValues,
        TimelineShown,
        setTimelineShown,
        timelineLoading,
        setTimlineLoading,
        IsBubbleChart,
        setIsBubbleChart,
        selectedPointCloudId,
        setSelectedPointCloudId,
        pointCloudList,
        setPointCloudList
      }}
    >
      {children}
    </UnityContext.Provider>
  );
};

export default function useUnity() {
  return useContext(UnityContext);
}